<template>
  <div>
    <div v-for="(item, index) in configIdpSSO" :key="index">
      <div class="box-config">
        <div class="d-flex align-items-center" style="gap: 10px">
          <div class="d-flex" style="padding: 10px 10px 0px 10px">
            <h4 class="config-title">{{ item.title }}</h4>
            <VueCustomTooltip
              v-show="item.tooltip"
              :label="item.tooltip"
              :multiline="true"
              size="is-large"
            >
              <svg width="16" height="16" class="ml-2 mb-1">
                <image
                  xlink:href="../../src/assets/svg/info-fill.svg"
                  width="16"
                  height="16"
                />
              </svg>
            </VueCustomTooltip>
          </div>
        </div>
        <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem" />
        <div class="d-flex justify-content-between" style="padding: 5px 10px">
          <div>
            <p class="m-0 config-content">{{ item.content }}</p>
          </div>
          <div
            v-show="item.title != 'Attribute'"
            @click="copyToClipboard(item.content)"
          >
            <VueCustomTooltip :label="$ml.get('copyContent')">
              <svg class="ico-20">
                <image
                  xlink:href="../assets/icons/copy-fill.svg"
                  width="20"
                  height="20"
                />
              </svg>
            </VueCustomTooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import ssoService from "../services/sso.service";
export default {
  name: "BoxInfo",
  data() {
    return {
      configIdpSSO: [
        {
          title: "User pool id",
          tooltip: this.$ml.get("userPoolId"),
          content: this.$ml.get("loading"),
        },
        {
          title: "User pool domain",
          tooltip: this.$ml.get("userPoolDomain"),
          content: this.$ml.get("loading"),
        },
        {
          title: "Redirect URL",
          tooltip: this.$ml.get("urlDomain"),
          content: this.$ml.get("emailContentSSO"),
        },
        {
          title: "Attribute",
          tooltip: "",
          content: this.$ml.get("emailContentSSO"),
          ex: this.$ml.get("emailExSSO"),
        },
      ],
    };
  },
  beforeMount() {
    this.getDataCognito();
  },
  methods: {
    async getDataCognito() {
      try {
        const { data } = await ssoService.getDataCognito();
        const { userPoolID, domain, redirectURL } = data;
        this.configIdpSSO[0].content = `urn:amazon:cognito:sp:${userPoolID}`;
        this.configIdpSSO[1].content = domain;
        this.configIdpSSO[2].content = redirectURL;
      } catch (error) {
        console.log(error.response.data);
      }
    },
    copyToClipboard(content) {
      navigator.clipboard
        .writeText(content)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("swalTitleCopy"),
            text: this.$ml.get("swalTextCopy"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
          });
        })
        .catch((err) => {
          console.error("Erro ao copiar o conteúdo: ", err);
        });
    },
  },
};
</script>
<style scoped>
.box-config {
  border: 1px solid rgb(0 0 0 / 10%);
  border-radius: 6px;
  /* padding: 10px; */
  margin-bottom: 15px;
}
.config-title {
  font-size: 16px;
  margin: 0px;
}
.config-content {
  font-weight: 400;
  font-size: 14px;
  color: #6f6f6f;
}
</style>
